import { render, staticRenderFns } from "./verPdf.vue?vue&type=template&id=0b95f3d6&"
import script from "./verPdf.vue?vue&type=script&lang=js&"
export * from "./verPdf.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports